// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2fqBi","actions":"GroupTable_actions__2UsT_","deleteModalFooter":"GroupTable_deleteModalFooter__2bT2k"};